import {Observable, Subscriber} from "rxjs";

export class SignalSubject<T> extends Observable<T>{
	public constructor(){
		super(subscriber=>{
			this.subscribers.push(subscriber);
			return ()=>{
				const i=this.subscribers.indexOf(subscriber);
				if(i>=0)
					this.subscribers.splice(i,1);
			};
		});
	}

	private subscribers:Subscriber<T>[]=[];
	public readonly completeThis=true;

	public next(v:T){
		for(const subscriber of this.subscribers)
			subscriber.next(v);
	}

	public complete(){
		for(const subscriber of this.subscribers)
			subscriber.complete();
		this.subscribers=[];
	}

	public asObservable():Observable<T>{
		return new Observable(subscriber=>this.subscribe({
			next: v=>subscriber.next(v),
			complete: ()=>subscriber.complete(),
			error: r=>subscriber.error(r),
		}));
	}
}